<template>
	<div class="tpl appointment-other-wrap">
		<mt-header title="" fixed>
		  <router-link :to="{name:fromPath.name}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="add-friend-btn"  icon="more" slot="right"></mt-button>
		</mt-header>
		<div class="user-info">
			<div class="user-img">
				<img :src="appointmentInfo.r_img||appointmentInfo.avatar"/>
			</div>
			<div class="user-text">
				<p class="user-intro">
					<span class="user-name">{{appointmentInfo.nickname}}</span>
					<span class="user-age">{{appointmentInfo.age}}岁</span>
					<img v-if="appointmentInfo.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
					<img v-if="appointmentInfo.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
				</p>
				<p class="user-sig">{{appointmentInfo.Message || "此用户很懒，没有约会寄语"}}</p>
				<p class="user-tags">
					<span class="is-pre-money" v-if="appointmentInfo.earnest_money==1">有诚意</span>
					<span class="is-gift" v-if="appointmentInfo.gift!=''">有礼物</span>
				</p>
				<div class="user-avatar">
					<img :src="appointmentInfo.avatar"/>
				</div>
			</div>
		</div>
		<div class="appointment-info">
			<ul>
				<li><img src="../../assets/img/finds/ic_find_detail_theme@2x.png" alt="" /><p>{{appointmentInfo.name}}</p></li>
				<li><img src="../../assets/img/finds/ic_find_detail_time@2x.png" alt="" /><p>{{appointmentInfo.release_time | toDateTime | convertTime("MM/DD HH:MM")}}</p></li>
				<li><img src="../../assets/img/finds/ic_find_detail_position@2x.png" alt="" /><p>{{appointmentInfo.region_name}}</p></li>
				<li>
					<img src="../../assets/img/finds/ic_find_detail_contype@2x.png" alt="" />
					<p>
						<span v-if="appointmentInfo.consumption_type==0">AA制</span>
						<span v-if="appointmentInfo.consumption_type==1">我买单</span>
						<span v-if="appointmentInfo.consumption_type==2">你买单</span>
					</p>
				</li>
				<li>
					<img src="../../assets/img/finds/ic_find_detail_sex@2x.png" alt="" />
					<p>
						<span v-if="appointmentInfo.girl_friend==0">性别不限</span>
						<span v-if="appointmentInfo.girl_friend==1">限男生</span>
						<span v-if="appointmentInfo.girl_friend==2">限女生</span>
					</p>
				</li>
				<li><img src="../../assets/img/finds/ic_find_detail_number@2x.png" alt="" /><p>1人</p></li>
				<li v-if="appointmentInfo.gift&&appointmentInfo.gift.length>0">
					<img :src="appointmentInfo.gift[0].girft_img_url" alt="" />
					<p>{{appointmentInfo.gift[0].girft_name}}*{{appointmentInfo.gift[0].g_nums}}</p>
				</li>
				<li class="more-gift-btn" @click="showMoreGift=1" v-if="appointmentInfo.gift&&appointmentInfo.gift.length>0">
					<img src="../../assets/img/finds/ic_find_list_more@3x.png" alt="" />
					<p>更多</p>
				</li>
			</ul>
		</div>
		<div class="appointment-joins">
			<div class="join-members">
				<div class="join-imgs">
					<img v-for="i in appointmentInfo.sign" :src="i.avatar" alt="" />
				</div>
				<span class="join-num" v-if="appointmentInfo.sign&&appointmentInfo.sign.length>3">{{appointmentInfo.sign.length-3}}人应约</span>
			</div>
			<button @click="joinAppointment(appointmentInfo.uid,appointmentInfo.r_id)">应约</button>
		</div>
		<div class="more-gift-wrap" v-if="showMoreGift" @click.self="showMoreGift=0">
			<div class="more-gift-list">
				<p class="title">更多礼物</p>
				<ul v-if="appointmentInfo.gift">
					<li v-for="item in appointmentInfo.gift">
						<img :src="item.girft_img_url"/>
						<p>{{item.girft_name}}*{{item.g_nums}}</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"appointment-other",
		data(){
			return{
				uid:"",
				aId:"",	//当前约会id
				fromPath:"",	//来源路由
				appointmentInfo:"",
				showMoreGift:0,
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.aId = this.$route.query.id;
			this.getAppointmentInfo();
		},
		beforeRouteEnter (to, from, next) {
            next((vm)=>{ //参数vm就是当前组件的实例。
                vm.fromPath = from;
                console.log(vm.fromPath)
            })
		},
		methods:{
			//获取约会信息
			getAppointmentInfo(){
				this.$axios({
					url:"Appointment/OtherAppointmentDetails",
					method:"post",
					data:{
						r_id:this.aId
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.appointmentInfo = res.data.data;
						console.log(this.appointmentInfo)
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			//申请应约
			joinAppointment(uid,id){
				if(uid==this.uid){
					this.$toast({
						message:"你确定要和自己约会么？",
						position:"bottom",
						duration:3000
					})
					return;
				}else{
					this.$axios({
						url:"Appointment/invitation",
						method:"post",
						data:{
							uid:this.uid,
							r_id:id,
							text:"我想约你~"
						}
					}).then(res=>{
						console.log(res);
							this.$toast({
								message:res.data.msg,
								position:"bottom",
								duration:3000
							})
					}).catch(err=>{
						console.log(err)
					})
				}
				
			},
		}
	}
</script>

<style scoped>
	.appointment-other-wrap{
		background: #fff;
		min-height: 100vh;
	}
	>>>.mint-button-icon{
		background: rgba(129,87,247,.3);
	    border-radius: 50%;
	    width: 2rem;
	    height: 2rem;
	    line-height: 2rem;
	    text-align: center;
	}
	>>>.mint-button-icon i{
		color: #fff;
	}
	.mint-header{
		background-color: rgba(255,255,255,0) !important;
		border-bottom: 0 !important;
	}
	
	.user-info{
		width: 100%;
		border-bottom: 1px solid #fafafa;
	}
	.user-info .user-img{
		width: 100%;
		max-height: 20rem;
		overflow: hidden;
	}
	.user-info .user-img img{
		width: 100%;
	}
	.user-info .user-text{
		background: #fff;
		width: 90%;
		margin: auto;
		position: relative;
		top: -2rem;
		padding: 1rem;
		border-radius: 5px;
		box-shadow: 1px 4px 1.5rem rgba(84,21,249,.1);
	}
	.user-info .user-text .user-avatar{
		width: 4rem;
		height: 4rem;
		overflow: hidden;
		border-radius: 50%;
		border: 3px solid #fff;
		position: absolute;
	    right: 0;
	    top: -2rem;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    background: #fff;
	}
	.user-info .user-text .user-avatar img{
		width: 100%;
	}
	.user-info .user-intro{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 1rem;
		color: #282828;
		line-height: 1.6rem;
	}
	.user-info .user-intro img{
		width: 1.5rem;
	}
	.user-info .user-intro .user-age{
		font-size: 0.8rem;
		margin: 0 0.5rem;
	}
	.user-info .user-sig{
		font-size: 1rem;
		color: #9e9e9e;
		line-height: 2rem;
	}
	.user-info .user-tags{
		padding: 0.5rem 0;
	}
	.user-info .user-tags span{
		font-size: 0.8rem;
	    border: 1px solid #ccc;
	    padding: 0.25rem 0.8rem;
	    border-radius: 4px;
	    color: #9e9e9e;
	}
	.user-info .user-tags span.is-pre-money{
		color: #6D34FB;
		border-color: #6D34FB;
	}
	.user-info .user-tags span.is-gift{
		color: #ff6261;
		border-color: #ff6261;
	}
	
	.appointment-info{
		border-bottom: 1px solid #f3f3f3;
	}
	.appointment-info ul{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.appointment-info ul li{
		width: 25%;
		text-align: center;
		border-right: 1px solid #f3f3f3;
		margin: 1rem 0;
		font-size: 0.8rem;
		color: #282828;
	}
	.appointment-info ul li img{
	    width: 2rem;
	    display: inline-block;
	    margin-bottom: 0.6rem;
	}
	.appointment-joins{
		padding: 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.appointment-joins .join-members{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.appointment-joins .join-imgs img{
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 50%;
		display: inline-block;
		border: 3px solid #fff;
	}
	.appointment-joins .join-imgs img:nth-of-type(2){
		position: relative;
		left: -10%;
	}
	.appointment-joins .join-imgs img:nth-of-type(3){
		position: relative;
		left: -20%;
	}
	.appointment-joins .join-num{
		font-size: 0.9rem;
		color: #282828;
	}
	.appointment-joins button{
		background: linear-gradient(to right,#9f7cfc,#b9a1ff);
		font-size: 0.8rem;
	    color: #fff;
	    border: 0;
	    outline: 0;
	    padding: 0.6rem 1.8rem;
	    border-radius: 4px;
	    box-shadow: 1px 4px 1.5rem rgba(129,87,247,.3);
	}
	.appointment-joins button:active{
		opacity: 0.8;
	}
	.more-gift-btn:active{
		opacity: 0.7;
	}
	.more-gift-wrap{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.3);
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 1rem;
	}
	.more-gift-list{
		width: 100%;
		background: #fff;
		border-radius: 5px;
		overflow: hidden;
		
	}
	.more-gift-list .title{
		font-size: 1rem;
		color: #282828;
		text-align: center;
		padding: 1rem;
	}
	.more-gift-list ul{
		width: 100%;
		overflow-x: scroll;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding-bottom: 1rem;
	}
	.more-gift-list li{
		margin: 0.5rem;
		text-align: center;
		color: #7b7b7b;
		font-size: 0.6rem;
	}
	.more-gift-list li:first-of-type{
		margin-left: 1.5rem;
	}
	.more-gift-list li:last-of-type{
		margin-right: 1.5rem;
	}
	.more-gift-list li img{
		width: 4rem;
		margin-bottom: 0.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/AppointmentOther.vue